import { useQuery } from '@tanstack/react-query'
import { brandingApi, type BrandingConfig } from '@/api/branding'

const DEFAULT_BRAND_NAME = 'DocumentIQ'
const DEFAULT_LOGO_URL = '/algoscale-logo.png'

export function useBranding() {
  const { data, isLoading } = useQuery<BrandingConfig>({
    queryKey: ['org-branding'],
    queryFn: brandingApi.get,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })

  return {
    brandName: data?.brand_name || DEFAULT_BRAND_NAME,
    brandLogoUrl: data?.brand_logo_url || DEFAULT_LOGO_URL,
    brandFaviconUrl: data?.brand_favicon_url || null,
    brandPrimaryColor: data?.brand_primary_color || null,
    isWhitelabel: data?.whitelabel_enabled ?? false,
    isLoading,
  }
}
